import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: Number = 0;

export const skipDataSlice = createSlice({
  name: 'skipData',
  initialState,
  reducers: {
    skipData: (state, action: PayloadAction<Number>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { skipData } = skipDataSlice.actions;

export default skipDataSlice.reducer;
